"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.MsgCancelAllResponse = exports.MsgCancelAll = exports.MsgCancelOrderResponse = exports.MsgCancelOrder = exports.MsgEditOrderResponse = exports.MsgEditOrder = exports.MsgCreateOrderResponse = exports.MsgCreateOrder = exports.MsgSetTradingFlagResponse = exports.MsgSetTradingFlag = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
exports.protobufPackage = "Switcheo.carbon.order";
const baseMsgSetTradingFlag = {
    creator: "",
    isEnabled: false,
    blockchain: "",
};
exports.MsgSetTradingFlag = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.isEnabled === true) {
            writer.uint32(16).bool(message.isEnabled);
        }
        if (message.blockchain !== "") {
            writer.uint32(26).string(message.blockchain);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetTradingFlag);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.isEnabled = reader.bool();
                    break;
                case 3:
                    message.blockchain = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetTradingFlag);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.isEnabled =
            object.isEnabled !== undefined && object.isEnabled !== null
                ? Boolean(object.isEnabled)
                : false;
        message.blockchain =
            object.blockchain !== undefined && object.blockchain !== null
                ? String(object.blockchain)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.isEnabled !== undefined && (obj.isEnabled = message.isEnabled);
        message.blockchain !== undefined && (obj.blockchain = message.blockchain);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgSetTradingFlag);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.isEnabled = (_b = object.isEnabled) !== null && _b !== void 0 ? _b : false;
        message.blockchain = (_c = object.blockchain) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgSetTradingFlagResponse = {};
exports.MsgSetTradingFlagResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetTradingFlagResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetTradingFlagResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetTradingFlagResponse);
        return message;
    },
};
const baseMsgCreateOrder = {
    creator: "",
    marketId: "",
    side: "",
    quantity: "",
    orderType: "",
    price: "",
    stopPrice: "",
    timeInForce: "",
    triggerType: "",
    isPostOnly: false,
    isReduceOnly: false,
    referralAddress: "",
    referralCommission: 0,
    referralKickback: 0,
};
exports.MsgCreateOrder = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        if (message.side !== "") {
            writer.uint32(26).string(message.side);
        }
        if (message.quantity !== "") {
            writer.uint32(34).string(message.quantity);
        }
        if (message.orderType !== "") {
            writer.uint32(42).string(message.orderType);
        }
        if (message.price !== "") {
            writer.uint32(50).string(message.price);
        }
        if (message.stopPrice !== "") {
            writer.uint32(58).string(message.stopPrice);
        }
        if (message.timeInForce !== "") {
            writer.uint32(66).string(message.timeInForce);
        }
        if (message.triggerType !== "") {
            writer.uint32(74).string(message.triggerType);
        }
        if (message.isPostOnly === true) {
            writer.uint32(80).bool(message.isPostOnly);
        }
        if (message.isReduceOnly === true) {
            writer.uint32(88).bool(message.isReduceOnly);
        }
        if (message.referralAddress !== "") {
            writer.uint32(98).string(message.referralAddress);
        }
        if (message.referralCommission !== 0) {
            writer.uint32(104).uint32(message.referralCommission);
        }
        if (message.referralKickback !== 0) {
            writer.uint32(112).uint32(message.referralKickback);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOrder);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                case 3:
                    message.side = reader.string();
                    break;
                case 4:
                    message.quantity = reader.string();
                    break;
                case 5:
                    message.orderType = reader.string();
                    break;
                case 6:
                    message.price = reader.string();
                    break;
                case 7:
                    message.stopPrice = reader.string();
                    break;
                case 8:
                    message.timeInForce = reader.string();
                    break;
                case 9:
                    message.triggerType = reader.string();
                    break;
                case 10:
                    message.isPostOnly = reader.bool();
                    break;
                case 11:
                    message.isReduceOnly = reader.bool();
                    break;
                case 12:
                    message.referralAddress = reader.string();
                    break;
                case 13:
                    message.referralCommission = reader.uint32();
                    break;
                case 14:
                    message.referralKickback = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreateOrder);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.side =
            object.side !== undefined && object.side !== null
                ? String(object.side)
                : "";
        message.quantity =
            object.quantity !== undefined && object.quantity !== null
                ? String(object.quantity)
                : "";
        message.orderType =
            object.orderType !== undefined && object.orderType !== null
                ? String(object.orderType)
                : "";
        message.price =
            object.price !== undefined && object.price !== null
                ? String(object.price)
                : "";
        message.stopPrice =
            object.stopPrice !== undefined && object.stopPrice !== null
                ? String(object.stopPrice)
                : "";
        message.timeInForce =
            object.timeInForce !== undefined && object.timeInForce !== null
                ? String(object.timeInForce)
                : "";
        message.triggerType =
            object.triggerType !== undefined && object.triggerType !== null
                ? String(object.triggerType)
                : "";
        message.isPostOnly =
            object.isPostOnly !== undefined && object.isPostOnly !== null
                ? Boolean(object.isPostOnly)
                : false;
        message.isReduceOnly =
            object.isReduceOnly !== undefined && object.isReduceOnly !== null
                ? Boolean(object.isReduceOnly)
                : false;
        message.referralAddress =
            object.referralAddress !== undefined && object.referralAddress !== null
                ? String(object.referralAddress)
                : "";
        message.referralCommission =
            object.referralCommission !== undefined &&
                object.referralCommission !== null
                ? Number(object.referralCommission)
                : 0;
        message.referralKickback =
            object.referralKickback !== undefined && object.referralKickback !== null
                ? Number(object.referralKickback)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.side !== undefined && (obj.side = message.side);
        message.quantity !== undefined && (obj.quantity = message.quantity);
        message.orderType !== undefined && (obj.orderType = message.orderType);
        message.price !== undefined && (obj.price = message.price);
        message.stopPrice !== undefined && (obj.stopPrice = message.stopPrice);
        message.timeInForce !== undefined &&
            (obj.timeInForce = message.timeInForce);
        message.triggerType !== undefined &&
            (obj.triggerType = message.triggerType);
        message.isPostOnly !== undefined && (obj.isPostOnly = message.isPostOnly);
        message.isReduceOnly !== undefined &&
            (obj.isReduceOnly = message.isReduceOnly);
        message.referralAddress !== undefined &&
            (obj.referralAddress = message.referralAddress);
        message.referralCommission !== undefined &&
            (obj.referralCommission = message.referralCommission);
        message.referralKickback !== undefined &&
            (obj.referralKickback = message.referralKickback);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const message = Object.assign({}, baseMsgCreateOrder);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        message.side = (_c = object.side) !== null && _c !== void 0 ? _c : "";
        message.quantity = (_d = object.quantity) !== null && _d !== void 0 ? _d : "";
        message.orderType = (_e = object.orderType) !== null && _e !== void 0 ? _e : "";
        message.price = (_f = object.price) !== null && _f !== void 0 ? _f : "";
        message.stopPrice = (_g = object.stopPrice) !== null && _g !== void 0 ? _g : "";
        message.timeInForce = (_h = object.timeInForce) !== null && _h !== void 0 ? _h : "";
        message.triggerType = (_j = object.triggerType) !== null && _j !== void 0 ? _j : "";
        message.isPostOnly = (_k = object.isPostOnly) !== null && _k !== void 0 ? _k : false;
        message.isReduceOnly = (_l = object.isReduceOnly) !== null && _l !== void 0 ? _l : false;
        message.referralAddress = (_m = object.referralAddress) !== null && _m !== void 0 ? _m : "";
        message.referralCommission = (_o = object.referralCommission) !== null && _o !== void 0 ? _o : 0;
        message.referralKickback = (_p = object.referralKickback) !== null && _p !== void 0 ? _p : 0;
        return message;
    },
};
const baseMsgCreateOrderResponse = {};
exports.MsgCreateOrderResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateOrderResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateOrderResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateOrderResponse);
        return message;
    },
};
const baseMsgEditOrder = {
    creator: "",
    id: "",
    quantity: "",
    price: "",
    stopPrice: "",
};
exports.MsgEditOrder = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.quantity !== "") {
            writer.uint32(26).string(message.quantity);
        }
        if (message.price !== "") {
            writer.uint32(34).string(message.price);
        }
        if (message.stopPrice !== "") {
            writer.uint32(42).string(message.stopPrice);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgEditOrder);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.quantity = reader.string();
                    break;
                case 4:
                    message.price = reader.string();
                    break;
                case 5:
                    message.stopPrice = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgEditOrder);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        message.quantity =
            object.quantity !== undefined && object.quantity !== null
                ? String(object.quantity)
                : "";
        message.price =
            object.price !== undefined && object.price !== null
                ? String(object.price)
                : "";
        message.stopPrice =
            object.stopPrice !== undefined && object.stopPrice !== null
                ? String(object.stopPrice)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined && (obj.id = message.id);
        message.quantity !== undefined && (obj.quantity = message.quantity);
        message.price !== undefined && (obj.price = message.price);
        message.stopPrice !== undefined && (obj.stopPrice = message.stopPrice);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgEditOrder);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        message.quantity = (_c = object.quantity) !== null && _c !== void 0 ? _c : "";
        message.price = (_d = object.price) !== null && _d !== void 0 ? _d : "";
        message.stopPrice = (_e = object.stopPrice) !== null && _e !== void 0 ? _e : "";
        return message;
    },
};
const baseMsgEditOrderResponse = {};
exports.MsgEditOrderResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgEditOrderResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgEditOrderResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgEditOrderResponse);
        return message;
    },
};
const baseMsgCancelOrder = { creator: "", id: "" };
exports.MsgCancelOrder = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCancelOrder);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCancelOrder);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgCancelOrder);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgCancelOrderResponse = {};
exports.MsgCancelOrderResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCancelOrderResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCancelOrderResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCancelOrderResponse);
        return message;
    },
};
const baseMsgCancelAll = { creator: "", marketId: "" };
exports.MsgCancelAll = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCancelAll);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCancelAll);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.marketId !== undefined && (obj.marketId = message.marketId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgCancelAll);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.marketId = (_b = object.marketId) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgCancelAllResponse = {};
exports.MsgCancelAllResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCancelAllResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCancelAllResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCancelAllResponse);
        return message;
    },
};
const baseMsgUpdateParams = { authority: "" };
exports.MsgUpdateParams = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            params_1.ParamsToUpdate.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = params_1.ParamsToUpdate.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority =
            object.authority !== undefined && object.authority !== null
                ? String(object.authority)
                : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined &&
            (obj.params = message.params
                ? params_1.ParamsToUpdate.toJSON(message.params)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgUpdateParams);
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.ParamsToUpdate.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseMsgUpdateParamsResponse = {};
exports.MsgUpdateParamsResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateParamsResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SetTradingFlag = this.SetTradingFlag.bind(this);
        this.CreateOrder = this.CreateOrder.bind(this);
        this.EditOrder = this.EditOrder.bind(this);
        this.CancelOrder = this.CancelOrder.bind(this);
        this.CancelAll = this.CancelAll.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    SetTradingFlag(request) {
        const data = exports.MsgSetTradingFlag.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "SetTradingFlag", data);
        return promise.then((data) => exports.MsgSetTradingFlagResponse.decode(new minimal_1.default.Reader(data)));
    }
    CreateOrder(request) {
        const data = exports.MsgCreateOrder.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "CreateOrder", data);
        return promise.then((data) => exports.MsgCreateOrderResponse.decode(new minimal_1.default.Reader(data)));
    }
    EditOrder(request) {
        const data = exports.MsgEditOrder.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "EditOrder", data);
        return promise.then((data) => exports.MsgEditOrderResponse.decode(new minimal_1.default.Reader(data)));
    }
    CancelOrder(request) {
        const data = exports.MsgCancelOrder.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "CancelOrder", data);
        return promise.then((data) => exports.MsgCancelOrderResponse.decode(new minimal_1.default.Reader(data)));
    }
    CancelAll(request) {
        const data = exports.MsgCancelAll.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "CancelAll", data);
        return promise.then((data) => exports.MsgCancelAllResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateParams(request) {
        const data = exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.order.Msg", "UpdateParams", data);
        return promise.then((data) => exports.MsgUpdateParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
